import { useEffect, useLayoutEffect } from "react";
import { useLenis } from "lenis/react";

export const useScrollReset = (key?: string) => {
  const lenis = useLenis();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [key]);

  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
  }, [key, lenis]);
};
